// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ContactsOutlinedSvg from "@ant-design/icons-svg/es/asn/ContactsOutlined";
import AntdIcon from '../components/AntdIcon';

var ContactsOutlined = function ContactsOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ContactsOutlinedSvg
  }));
};

ContactsOutlined.displayName = 'ContactsOutlined';
export default React.forwardRef(ContactsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ContactsOutlined.js
// module id = 853
// module chunks = 0